import { Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideBell, lucideBellOff } from '@ng-icons/lucide';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmPopoverImports } from '@spartan-ng/helm/popover';

/**
 * Bell in the app header (Figma "AppHeader"). The API does not deliver notifications yet, so the
 * popover only states that there are none.
 */
@Component({
  selector: 'app-notifications-button',
  templateUrl: './notifications-button.html',
  imports: [NgIcon, TranslatePipe, HlmButtonImports, HlmPopoverImports],
  providers: [provideIcons({ lucideBell, lucideBellOff })],
})
export class NotificationsButton { }
